export const noLogger = () => { };
export const makeLogger = (prefix) => (level, ...args) => {
    if (level === 'critical') {
        args.unshift('[CRITICAL]');
    }
    if (prefix) {
        args.unshift(`[${prefix}]`);
    }
    if (level === 'critical') {
        console.error(...args);
    }
    else {
        console[level](...args);
    }
};
export function debugLogger(prefix) {
    if (!localStorage.getItem('DEBUG')) {
        return noLogger;
    }
    return makeLogger(prefix);
}
//# sourceMappingURL=logger.js.map